import React from 'react'
import { useRisksContext } from 'src/pages/Risks/context/RisksContext'
import {
  GridColumnSortActionRisks,
  GridColumnSortActionRiskControls,
} from './GridColumnSort.constants'
import { getColSortIcon } from './GridColumnSort.utils'
import { GridColumnSort } from '.'

export const RiskGridColumnSort = ({
  type,
  colName,
}: GridColumnSortActionRisks): JSX.Element | null => {
  const { sortColumn, setSortColumn, setSortType } = useRisksContext()
  const currIcon = getColSortIcon(type, colName === sortColumn)
  const applySorting = () => {
    if (colName === sortColumn) {
      setSortType((prevType) => (prevType === 'asc' ? 'desc' : 'asc'))
    } else {
      setSortColumn(colName)
      setSortType('asc')
    }
  }

  return (
    <GridColumnSort
      {...{ colName, showSpinner: false, currIcon, applySorting }}
    />
  )
}

export const RiskControlGridColumnSort = ({
  type,
  colName,
}: GridColumnSortActionRiskControls): JSX.Element | null => {
  const { controlSortColumn, setControlSortColumn, setControlSortType } =
    useRisksContext()
  const currIcon = getColSortIcon(type, colName === controlSortColumn)
  const applySorting = () => {
    if (colName === controlSortColumn) {
      setControlSortType((prevType) => (prevType === 'asc' ? 'desc' : 'asc'))
    } else {
      setControlSortColumn(colName)
      setControlSortType('asc')
    }
  }

  return (
    <GridColumnSort
      {...{ colName, showSpinner: false, currIcon, applySorting }}
    />
  )
}
